import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

function StreamDefaultSettings() {
    const { t } = useTranslation();
    return (
        <div className="stream-default-settings-container">
            <Typography variant="h2" className="stream-default-settings-title">{t('header.stream_modal.stream_default_setting')}</Typography>
        </div>
    );
}

export default StreamDefaultSettings;